import { api } from 'common';

import { HccBlockFormFields } from './FormFields';
import { HccBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const hccAlgorithmNodeConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'clinicalAlgorithm',
  defaultConfig: {
    agent: '',
    flowDefinitionIds: [],
    payload: {
      documents: {
        sourceBlockName: '',
      },
      problems: {
        sourceBlockName: '',
      },
      medications: {
        sourceBlockName: '',
      },
      labValues: {
        sourceBlockName: '',
      },
      procedures: {
        sourceBlockName: '',
      },
    },
  },
  configFields: {
    schema: api.FlowDefinition.HccAlgorithmBlockConfigSchema,
    FormFields: HccBlockFormFields,
  },
  documentationMarkdown: HccBlockDocumentationMarkdown,
};
